module.exports = __webpack_public_path__ + "static/media/paleta.03d876e7.jpeg";